<div class="min-h-screen bg-gray-50">
  <p-toast></p-toast>
  <p-confirmDialog 
    [style]="{'width': '450px'}"
    [baseZIndex]="10000"
    rejectButtonStyleClass="p-button-text">
  </p-confirmDialog>

  <div class="w-full md:max-w-6xl mx-auto">
    <div class="flex flex-col md:flex-row gap-3">
      <!-- Left Sidebar - Navigation -->
      <div class="w-full md:w-80 flex-shrink-0">
        <p-card class="h-fit">
          <!-- User Info Section -->
          <div class="text-center mb-6 pt-3">
            <p-avatar [label]="getInitials(currentUser?.firstName || '', currentUser?.lastName || '')" size="xlarge" styleClass="bg-blue-600 text-white text-2xl font-semibold mb-4">
            </p-avatar>
            <h3 class="text-xl font-bold text-gray-900 mb-1">
              {{ currentUser?.firstName }} {{ currentUser?.lastName }}
            </h3>
            <p class="text-gray-600 text-sm mb-2">
              {{ currentUser?.email }}
            </p>
            @if (currentUser?.roleId?.name) {
            <div class="flex justify-center">
              <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium text-white" [ngClass]="getRoleBasedColor(currentUser?.roleId?.identification || '')">
                {{ currentUser?.roleId?.name }}
              </span>
            </div>
            }
          </div>

          <!-- Navigation Links -->
          <div class="space-y-2 tab-navigation">
            <p-menu [model]="navigationItems" styleClass="w-full border-0">
            </p-menu>
          </div>
        </p-card>
      </div>

      <!-- Right Content Area -->
      <div class="flex-1">
        <!-- My Details Tab -->
        @if (activeTab === 'details') {
        <p-card class="h-fit">
          <div>
            <div class="p-4 flex justify-between items-center">
              <div>
                <h2 i18n>My Details</h2>
                <p class="text-gray-600 mt-1" i18n>View and manage your personal information</p>
              </div>
              <p-button appGlobalLoadingDisable icon="pi pi-refresh" [loading]="loading" (onClick)="refreshUserProfile()" styleClass="p-button-outlined p-button-secondary" i18n-title title="Refresh Profile">
              </p-button>
            </div>
          </div>

          @if (currentUser) {
          <div class="p-4">
            <!-- Personal Details Section -->
            <div class="mb-8">
              <h3 class="mb-4" i18n>Personal Details</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="form-field">
                  <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Title</label>
                  <p class="field-value">{{ currentUser.title || 'N/A' }}</p>
                </div>
                <div class="form-field">
                  <label class="block text-sm font-medium text-gray-700 mb-1" i18n>First Name</label>
                  <p class="field-value">{{ currentUser.firstName }}</p>
                </div>
                <div class="form-field">
                  <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Surname</label>
                  <p class="field-value">{{ currentUser.lastName }}</p>
                </div>
                <div class="form-field">
                  <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Username</label>
                  <p class="field-value">{{ currentUser.email }}</p>
                </div>
                <div class="form-field">
                  <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Email</label>
                  <p class="field-value">{{ currentUser.email }}</p>
                </div>
                <div class="form-field">
                  <div class="flex items-center justify-between mb-1">
                    <label class="block text-sm font-medium text-gray-700" i18n>Mobile Number</label>
                    @if (!editingPhone) {
                    <p-button 
                      icon="pi pi-pencil" 
                      styleClass="p-button-text p-button-sm" 
                      (onClick)="startEditingPhone()"
                      i18n-title
                      title="Edit phone number">
                    </p-button>
                    }
                  </div>
                  @if (editingPhone) {
                  <form [formGroup]="phoneForm" class="space-y-3">
                    <input 
                      type="text" 
                      pInputText 
                      formControlName="mobileNumber" 
                      placeholder="Enter phone number"
                      class="w-full"
                      [class.ng-invalid]="phoneForm.get('mobileNumber')?.invalid && phoneForm.get('mobileNumber')?.touched">
                    <small class="text-red-500 text-sm" *ngIf="phoneForm.get('mobileNumber')?.invalid && phoneForm.get('mobileNumber')?.touched">
                      Please enter a valid phone number
                    </small>
                    <div class="flex gap-2 justify-end">
                      <p-button 
                        label="Cancel" 
                        styleClass="p-button-text p-button-sm" 
                        (onClick)="cancelEditingPhone()"
                        [disabled]="updatingPhone">
                      </p-button>
                      <p-button 
                        label="Save" 
                        styleClass="p-button-sm" 
                        (onClick)="savePhone()"
                        [loading]="updatingPhone"
                        [disabled]="phoneForm.invalid || updatingPhone">
                      </p-button>
                    </div>
                  </form>
                  } @else {
                  <p class="field-value">{{ currentUser.mobileNumber || 'N/A' }}</p>
                  }
                </div>
              </div>
            </div>

            <!-- Role Information Section -->
            @if (currentUser?.roleId) {
            <div class="mb-8">
              <h3 class="mb-4" i18n>Role Information</h3>
              <div class="role-info-section bg-gray-50 rounded-lg p-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div class="form-field">
                    <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Role</label>
                    <div class="flex items-center gap-2">
                      <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium text-white" [ngClass]="getRoleBasedColor(currentUser?.roleId?.identification || '')">
                        {{ currentUser?.roleId?.identification }}
                      </span>
                    </div>
                  </div>
                  @if (currentUser?.roleId?.name) {
                  <div class="form-field">
                    <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Role Name</label>
                    <p class="field-value">{{ currentUser?.roleId?.name }}</p>
                  </div>
                  }
                </div>
              </div>
            </div>
            }

            <!-- Residential Address Section -->
            <div class="mb-8">
              <div class="flex items-center justify-between mb-4">
                <h3 i18n>Residential Address</h3>
                @if (!editingAddress) {
                <p-button 
                  icon="pi pi-pencil" 
                  styleClass="p-button-text p-button-sm" 
                  (onClick)="startEditingAddress()"
                  i18n-title
                  title="Edit address">
                </p-button>
                }
              </div>
              <div class="address-section bg-gray-50 rounded-lg p-4">
                @if (editingAddress) {
                <form [formGroup]="addressForm" class="space-y-4">
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1" i18n>House Number</label>
                      <input 
                        type="text" 
                        pInputText 
                        formControlName="houseNumber" 
                        placeholder="Enter house number"
                        class="w-full">
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Street Address</label>
                      <input 
                        type="text" 
                        pInputText 
                        formControlName="streetAddress" 
                        placeholder="Enter street address"
                        class="w-full">
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1" i18n>City</label>
                      <input 
                        type="text" 
                        pInputText 
                        formControlName="city" 
                        placeholder="Enter city"
                        class="w-full">
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Country</label>
                      <input 
                        type="text" 
                        pInputText 
                        formControlName="country" 
                        placeholder="Enter country"
                        class="w-full">
                    </div>
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Postal Code</label>
                      <input 
                        type="text" 
                        pInputText 
                        formControlName="postcode" 
                        placeholder="Enter postal code"
                        class="w-full">
                    </div>
                  </div>
                  <div class="flex gap-2 justify-end pt-2">
                    <p-button 
                      label="Cancel" 
                      styleClass="p-button-text p-button-sm" 
                      (onClick)="cancelEditingAddress()"
                      [disabled]="updatingAddress">
                    </p-button>
                    <p-button 
                      label="Save" 
                      styleClass="p-button-sm" 
                      (onClick)="saveAddress()"
                      [loading]="updatingAddress"
                      [disabled]="addressForm.invalid || updatingAddress">
                    </p-button>
                  </div>
                </form>
                } @else {
                <p class="text-gray-900" *ngIf="currentUser.address?.streetAddress || currentUser.address?.city; else noAddress">
                  {{ currentUser.address?.houseNumber || '' }}
                  {{ currentUser.address?.streetAddress || '' }},<br>
                  {{ currentUser.address?.city || '' }},<br>
                  {{ currentUser.address?.country || '' }},<br>
                  <span i18n>Postal Code</span>: {{ currentUser.address?.postcode || 'N/A' }}
                </p>
                <ng-template #noAddress>
                  <p class="no-address" i18n>No address information available</p>
                </ng-template>
                }
              </div>
            </div>

            <!-- Identification and Business Section -->
            <div class="mb-8">
              <h3 class="mb-4" i18n>Identification and Business</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="form-field">
                  <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Citizenship</label>
                  <p class="field-value">{{ currentUser.citizenship || 'N/A' }}</p>
                </div>
                <div class="form-field">
                  <label class="block text-sm font-medium text-gray-700 mb-1" i18n>National Insurance Number</label>
                  <p class="field-value">{{ currentUser.nationalInsuranceNo || 'N/A' }}</p>
                </div>
                <div class="form-field">
                  <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Tax Number</label>
                  <p class="field-value">{{ currentUser.taxNumber || 'N/A' }}</p>
                </div>
                <div class="form-field">
                  <label class="block text-sm font-medium text-gray-700 mb-1" i18n>Trade Licence</label>
                  <p class="field-value">{{ currentUser.tradeLicence || 'N/A' }}</p>
                </div>
              </div>
            </div>

            @if (currentUser.idCard) {
            <!-- ID Card Section -->
            <div class="id-card-section">
              <h3 class="mb-4" i18n>ID Card</h3>
              <div class="flex items-center gap-3">
                <i [class]="getFileIcon(currentUser.idCard || '').icon + ' ' + getFileIcon(currentUser.idCard || '').color + ' text-xl'"></i>
                <span class="text-gray-900">{{ currentUser.idCard }}</span>
                <button class="ml-auto p-2 text-gray-600 hover:text-gray-900 download-button" i18n-title title="Download ID Card" (click)="downloadIdCard(currentUser.idCard!)" [disabled]="!currentUser.idCard">
                  <i class="pi pi-download"></i>
                </button>
              </div>

            </div>
            }
            </div>
          }
        </p-card>
        }

        <!-- Products Tab -->
        @if (activeTab === 'products') {
        <p-card>
          <div>
            <div class="p-4">
              <h2 i18n>My Products</h2>
              <p class="text-gray-600 mt-1" i18n>View your assigned product access</p>
            </div>
          </div>

          <div class="p-4">
            @if (getCurrentUserProducts().length > 0) {
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div *ngFor="let product of getCurrentUserProducts()" class="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border">
                <i class="pi pi-box text-blue-500 text-xl"></i>
                <div>
                  <div class="font-medium text-gray-900">{{ product.name }}</div>
                  <div class="text-sm text-gray-500">{{ product.code }}</div>
                </div>
              </div>
            </div>
            } @else {
            <div class="text-center py-8">
              <i class="pi pi-box text-4xl text-gray-300 mb-4 block"></i>
              <h3 class="text-lg font-medium text-gray-600 mb-2" i18n>No Products Assigned</h3>
              <p class="text-gray-500" i18n>You don't have access to any products yet. Contact your administrator for access.</p>
            </div>
            }
          </div>
        </p-card>
        }

        <!-- Territories Tab -->
        @if (activeTab === 'territories') {
        <p-card>
          <div>
            <div class="p-4">
              <h2 i18n>My Territories</h2>
              <p class="text-gray-600 mt-1" i18n>View your assigned territory access</p>
            </div>
          </div>

          <div class="p-4">
            @if (getCurrentUserTerritoryRegions().length > 0) {
            <p-accordion [value]="0" class="w-full">
              <p-accordion-panel 
                *ngFor="let region of getCurrentUserTerritoryRegions(); let i = index" 
                [value]="i"
              >
                <p-accordion-header>
                  <div class="flex items-center gap-2">
                    <i class="pi pi-map text-green-500"></i>
                    <span class="font-medium">{{ region }}</span>
                    <span class="text-sm text-gray-500">({{ getCurrentUserTerritoriesForRegion(region).length }} territories)</span>
                  </div>
                </p-accordion-header>
                <p-accordion-content>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-3 pt-4">
                    <div 
                      *ngFor="let territory of getCurrentUserTerritoriesForRegion(region)" 
                      class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border"
                    >
                      <i class="pi pi-map-marker text-green-500"></i>
                      <span class="text-gray-900 font-medium">{{ territory.name }}</span>
                    </div>
                  </div>
                </p-accordion-content>
              </p-accordion-panel>
            </p-accordion>
            } @else {
            <div class="text-center py-8">
              <i class="pi pi-map text-4xl text-gray-300 mb-4 block"></i>
              <h3 class="text-lg font-medium text-gray-600 mb-2" i18n>No Territories Assigned</h3>
              <p class="text-gray-500" i18n>You don't have access to any territories yet. Contact your administrator for access.</p>
            </div>
            }
          </div>
        </p-card>
        }

        <!-- Settings Tab -->
        @if (activeTab === 'settings') {
        <p-card>
          <div>
            <div class="p-4">
              <h2 i18n>Settings</h2>
              <p class="text-gray-600 mt-1" i18n>Manage your application preferences</p>
            </div>
          </div>

          <div class="p-4">
            <!-- Language Settings -->
            <div class="mb-8">
              <h3 class="mb-4" i18n>Language Preferences</h3>
              <p class="text-sm text-gray-600 mb-4" i18n>Select your preferred language for the application interface</p>
              
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                @for (language of availableLanguages; track language.code) {
                <div 
                  class="language-option p-4 border-2 rounded-lg cursor-pointer transition-all hover:shadow-md"
                  [class.border-blue-500]="selectedLanguage === language.code"
                  [class.bg-blue-50]="selectedLanguage === language.code"
                  [class.border-gray-200]="selectedLanguage !== language.code"
                  (click)="changeLanguage(language.code)"
                >
                  <div class="flex items-center gap-3">
                    <span class="text-3xl">{{ language.flag }}</span>
                    <div>
                      <div class="font-medium text-gray-900">{{ language.name }}</div>
                      <div class="text-xs text-gray-500">{{ language.code }}</div>
                    </div>
                    @if (selectedLanguage === language.code) {
                    <i class="pi pi-check-circle text-blue-600 ml-auto text-xl"></i>
                    }
                  </div>
                </div>
                }
              </div>
              
              <div class="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                <p class="text-sm text-yellow-800">
                 
                  <span i18n>⚠️ Note: Changing your language will reload the application and you will be logged out. You will need to sign in again after the language change.</span>
                </p>
              </div>
            </div>

            <!-- Other Settings -->
           
          </div>
        </p-card>
        }

        <!-- Password Tab -->
        @if (activeTab === 'password') {
        <p-card>
          <div>
            <div class="p-4">
              <h2 i18n>Password</h2>
              <p class="text-gray-600 mt-1" i18n>Update your password to keep your account secure</p>
            </div>
          </div>

          <div class="p-4">
            <form [formGroup]="passwordForm" class="space-y-6">
              <div class="space-y-4">
                <!-- Current Password -->
                <div>
                  <label for="currentPassword" class="block text-sm font-medium text-gray-700 mb-2" i18n>
                    Current Password <span class="text-red-500">*</span>
                  </label>
                  <p-password fluid id="currentPassword" formControlName="currentPassword" i18n-placeholder placeholder="Enter current password" [toggleMask]="true" [feedback]="false" styleClass="w-full" [class.ng-invalid]="passwordForm.get('currentPassword')?.invalid && passwordForm.get('currentPassword')?.touched">
                    <ng-template pTemplate="header">
                      <i class="pi pi-lock text-gray-500"></i>
                    </ng-template>
                  </p-password>
                  <small class="text-red-500 text-sm mt-1" *ngIf="getFieldError('currentPassword')">
                    {{ getFieldError('currentPassword') }}
                  </small>
                </div>

                <!-- New Password -->
                <div>
                  <label for="newPassword" class="block text-sm font-medium text-gray-700 mb-2" i18n>
                    New Password <span class="text-red-500">*</span>
                  </label>
                  <p-password fluid id="newPassword" formControlName="newPassword" i18n-placeholder placeholder="Enter new password" [toggleMask]="true" [feedback]="false"  styleClass="w-full" [class.ng-invalid]="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched">
                    <ng-template pTemplate="header">
                      <i class="pi pi-lock text-gray-500"></i>
                    </ng-template>
                  </p-password>
                  <!-- <small class="text-red-500 text-sm mt-1" *ngIf="getFieldError('newPassword')">
                    {{ getFieldError('newPassword') }}
                  </small> -->
                  <small class="text-gray-500 text-sm mt-1" i18n>
                    Password must be at least 8 characters long, contain at least one lowercase letter, one uppercase letter, one digit, and one special character (e.g., @, #, $, _, etc.).
                  </small>

                  <!-- Password Strength Indicator -->
                  <div class="mt-2" *ngIf="passwordForm.get('newPassword')?.value">
                    <div class="flex items-center gap-2 mb-1">
                      <span class="text-xs text-gray-600" i18n>Strength:</span>
                      <span class="text-xs font-medium" [class]="getCurrentPasswordStrength().color === 'bg-red-500' ? 'text-red-600' : getCurrentPasswordStrength().color === 'bg-yellow-500' ? 'text-yellow-600' : getCurrentPasswordStrength().color === 'bg-blue-500' ? 'text-blue-600' : 'text-green-600'">
                        {{ getCurrentPasswordStrength().label }}
                      </span>
                    </div>
                    <div class="flex gap-1">
                      <div *ngFor="let i of [1,2,3,4,5]" class="h-1 flex-1 rounded transition-all duration-200" [class]="i <= getCurrentPasswordStrength().score ? getCurrentPasswordStrength().color : 'bg-gray-200'">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Confirm Password -->
                <div>
                  <label for="confirmPassword" class="block text-sm font-medium text-gray-700 mb-2" i18n>
                    Confirm Password <span class="text-red-500">*</span>
                  </label>
                  <p-password fluid id="confirmPassword" formControlName="confirmPassword" i18n-placeholder placeholder="Confirm new password" [toggleMask]="true" [feedback]="false" styleClass="w-full" [class.ng-invalid]="passwordForm.get('confirmPassword')?.invalid && passwordForm.get('confirmPassword')?.touched">
                    <ng-template pTemplate="header">
                      <i class="pi pi-lock text-gray-500"></i>
                    </ng-template>
                  </p-password>
                  <small class="text-red-500 text-sm mt-1" *ngIf="getFieldError('confirmPassword')">
                    {{ getFieldError('confirmPassword') }}
                  </small>
                  <small class="text-red-500 text-sm mt-1" *ngIf="getPasswordMismatchError()">
                    {{ getPasswordMismatchError() }}
                  </small>
                </div>
              </div>

              <!-- Submit Button -->
              <div class="flex justify-end pt-4">
                <p-button type="submit" i18n-label label="Update Password" [loading]="updatingPassword" [disabled]="passwordForm.invalid || updatingPassword" styleClass="bg-gray-900 hover:bg-gray-800" (onClick)="onPasswordSubmit()">

                </p-button>
              </div>
            </form>
          </div>
        </p-card>
        }
      </div>
    </div>
  </div>
</div>

<!-- Loading Template -->
<ng-template #loadingDetails>
  <div class="p-6 text-center">
    <i class="pi pi-spin pi-spinner text-2xl text-gray-400"></i>
    <p class="text-gray-500 mt-2" i18n>Loading user details...</p>
  </div>
</ng-template>